import React from "react";
import AppleBadge from "./rsc/AppleBadge.svg";
import MicrosoftBadge from "./rsc/MicrosoftBadge.png";
import SteamBadge from "./rsc/Steam.jpg";

export default class DownloadLinks extends React.Component {
    render() {
        return (
            <div style={{marginBottom: "5vh"}}>
                <a href="https://apps.apple.com/us/app/kartfinity/id1479337138" target="_blank" rel="noreferrer">
                    <img src={AppleBadge} alt="Download on the Mac App Store" style={{height: "75px"}} />
                </a>
                <a href="https://www.microsoft.com/store/apps/9nx4z7mjrkj1?cid=storebadge&ocid=badge" target="_blank" rel="noreferrer">
                    <img src={MicrosoftBadge} alt="Get it on from Microsoft" style={{height: "75px", marginLeft: "10px"}}/>
                </a>
                <a href="https://store.steampowered.com/app/4050930/Kartfinity/" target="_blank" rel="noreferrer">
                    <img src={SteamBadge} alt="Get it on Steam" style={{
                        height: "75px",
                        marginLeft: "10px",
                        borderRadius: "10px",
                        padding: "5px",
                        boxSizing: "border-box",
                        background: "white"
                    }}/>
                </a>
            </div>
        );
    }
}